var n = "function" == typeof Bun && Bun && "string" == typeof Bun.version;
export { n as e };